module.exports = __webpack_public_path__ + "images/david1.jpg";